import { IAppConfig } from "../models"

const APP_CONFIG_DEV = require('./app.config.dev.json')
const APP_CONFIG_PROD = require('./app.config.prod.json')

export const APP_CONFIG: IAppConfig = process.env.REACT_APP_ENVIRONMENT === 'develop' ? APP_CONFIG_DEV : APP_CONFIG_PROD